import React from 'react';

import FooterRoutes from '../../Utils/Routes/footer.routes';
import { generateRoutes } from '../../Utils/generateRoutes';
import { FooterRouterStyled } from './FooterRouter.Styles';

const FooterRouter = () => (
  <FooterRouterStyled className="footer-router">{generateRoutes(FooterRoutes)}</FooterRouterStyled>
);

export default FooterRouter;
